import { render, staticRenderFns } from "./jkfillDetail.vue?vue&type=template&id=c9c0132a&scoped=true&"
import script from "./jkfillDetail.vue?vue&type=script&lang=js&"
export * from "./jkfillDetail.vue?vue&type=script&lang=js&"
import style0 from "./jkfillDetail.vue?vue&type=style&index=0&id=c9c0132a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c0132a",
  null
  
)

export default component.exports